import React from 'react';
import { useInView } from 'react-intersection-observer';

const Item = ({ title, tech, client, industry, url  }) => {
    return (
    <div className='gallery-item'>
        {url 
            ? 
            <a href={url} target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 55 56" fill="none">
                    <path d="M31.9443 8.58563C32.7286 7.80793 33.995 7.81335 34.7727 8.59773L52.7357 26.715C53.5134 27.4994 53.508 28.7657 52.7236 29.5434L34.6479 47.4653C33.8635 48.243 32.5972 48.2376 31.8195 47.4532L28.3461 43.95C27.5684 43.1656 27.5738 41.8993 28.3582 41.1216L33.4401 36.0829C34.7035 34.8302 33.8251 32.6752 32.046 32.6627L6.54044 32.483C5.446 32.4753 4.56103 31.5894 4.55456 30.4949L4.52449 25.4016C4.51794 24.2926 5.41505 23.39 6.52409 23.3898L32.1452 23.3851C33.9227 23.3848 34.8166 21.2392 33.5651 19.977L28.4743 14.8425C27.6966 14.0581 27.702 12.7918 28.4864 12.0141L31.9443 8.58563Z" fill="#ffffff"/>
                </svg>
                <h6>{title}</h6>
                <div className='gallery-item-tags'>
                    <span>{tech}</span>
                    <span>{client}</span>
                    <span>{industry}</span>
                </div>
            </a>
            :
            <span className='gallery-item-wrapper'>
                <h6>{title}</h6>
                <div className='gallery-item-tags'>
                    <span>{tech}</span>
                    <span>{client}</span>
                    <span>{industry}</span>
                </div>
            </span>
        }
    </div>
  );
};

const Gallery = () => {
    // in viewport
    const { ref, inView } = useInView({
        threshold: 0.1,
    });

    const projects = [
        {
            title: "Noble Gallery",
            tech: "web3 / ReactJS",
            client: "Freelance / USA",
            industry: "NFT Gallery",
            url: "https://noblegallery.com"
        },
        {
            title: "Shift",
            tech: "web3 / ReactJS",
            client: "Freelance / USA",
            industry: "NFT Gallery",
            url: "https://www.bhais.art"
        },
        {
            title: "Citrus",
            tech: "web3 / ReactJS",
            client: "Freelance / USA",
            industry: "NFT Community",
        },
        {
            title: "Me Llamo Art",
            tech: "ReactJS",
            client: "Freelance / USA",
            industry: "NFT Community",
            url: "https://mellamoart.com",
        },
        {
            title: "Tier Zero",
            tech: "VueJS / Contentful",
            client: "Freelance / Toronto",
            industry: "Creative Agency",
            url: "https://tierzero.co"
        },
        {
            title: "XA Network",
            tech: "Wordpress",
            client: "Freelance / Singapore",
            industry: "Investment Network",
        },
        {
            title: "Mamady Conde",
            tech: "Wordpress",
            client: "Freelance / LA",
            industry: "Film Director",
            url: "https://mamadyconde.com"
        },
        {
            title: "GFM Estudio",
            tech: "Wordpress",
            client: "Freelance / Barcelona",
            industry: "Interior Designer",
            url: "https://gfm-estudio.com"
        },
        {
            title: "Rubrick",
            tech: "Wordpress",
            client: "Freelance / Bucharest",
            industry: "Architecture Firm",
            url: "https://rubrick.ro"
        },
        {
            title: "Blue Tempe",
            tech: "VueJS",
            client: "Freelance / Myanmar",
            industry: "Architecture Firm",
            url: "https://blue-temple.com/"
        },
        {
            title: "HAKRO",
            tech: "VueJS / GSAP",
            client: "Freelance / Hamburg",
            industry: "Activewear"
        },
        {
            title: "Matterport",
            tech: "ReactJS / GSAP",
            client: "w/ Siberia / USA",
            industry: "Tech"
        },
        {
            title: "NESTLé",
            tech: "Chrome Extension",
            client: "w/ Siberia / USA",
            industry: "Tech"
        },
        {
            title: "Cannes Lions",
            tech: "ReactJS / Installation",
            client: "w/ Siberia / London",
            industry: "Tech"
        },
        {
            title: "One United",
            tech: "ReactJS",
            client: "Freelance / Bucharest",
            industry: "Tech"
        },
        {
            title: "Tommy Hilfiger",
            tech: "Web",
            client: "w/ AKQA AMS",
            industry: "Fashion"
        },
        {
            title: "Hermès",
            tech: "Web",
            client: "w/ AKQA AMS",
            industry: "Fashion"
        },
        {
            title: "MINI",
            tech: "Web",
            client: "w/ AKQA AMS",
            industry: "Automotive"
        },
        {
            title: "Mercedes-Benz",
            tech: "Creative / Tech",
            client: "w/ antoni Berlin",
            industry: "Automotive"
        },
        {
            title: "Tech R&D",
            tech: "Python, RPi",
            client: "Freelance",
            industry: "Tech"
        }
    ]

    return (
    <div className='gallery' ref={ref}>
        <h2>
            <span className='projects-words-wrapper' data-show={inView}>
                <span>Projects</span>
            </span>
            <span className='projects-words-wrapper' data-show={inView}>
                <span>in&nbsp;a&nbsp;nutshell</span>
            </span>
        </h2>
        <div className="gallery-wrapper">
            {projects.map((data,i) => {
                return (
                    <Item 
                        title={data.title}
                        tech={data.tech}
                        client={data.client}
                        industry={data.industry}
                        url={data.url}
                    />
                )
            })}
        </div>
    </div>
    );
};

export default Gallery;
